<template>
    <el-dialog
      title="新增分组"
      :visible="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
    >
        <el-form :model="form" ref="form" label-width="160px" class="selfForm">
            <el-form-item label="父级分组：">
                <el-tree v-if="lists && lists.length > 0"
                    ref="dataTree"
                    :data="lists"
                    show-checkbox
                    :default-checked-keys="defaultCheckedNode"
                    :default-expanded-keys="defaultCheckedNode"
                    node-key="id"
                    :check-strictly="true"
                    @check-change="checkChange"
                ></el-tree>
            </el-form-item>
            <el-form-item
                label="分组名称："
                prop="label"
                :rules="{required: true, message: '必填项', trigger: 'blur'}"
            >
                <el-input v-model="form.label"></el-input>
            </el-form-item>
            <el-form-item label="地址：">
                <el-input v-model="form.url"></el-input>
            </el-form-item>
            <el-form-item label="模块：">
                <data-table ref="refIns" :checkeds="form.insIds" @insIdsCallback="insIdsCallback"/>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="save">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
import { Loading } from "element-ui";
import DataTable from "./DataTable"
export default {
    components: { DataTable },
    props: {
        visible: {
            type: Boolean
        },
        // 标识新增或编辑
        type: {
            type: String,
            default: 'add'
        },
        // 分组信息
        row: {
            type: Object
        },

        // 分组列表, 用于显示父子关系
        lists: {
            type: Array
        }
    },
    data: vm=>({
        search: null,
        form: {
            id: '',
            pid: 0,
            label: '',
            url: '',
            // checkeds: [], //该分组下模块列表
            insIds: [], //勾选的实例id
        }
    }),
    computed: {
        defaultCheckedNode(){
            if(this.form.pid){
                return [this.form.pid]
            }else{
                return []
            }
        }
    },
    created(){
        if(this.type == 'edit'){
            this.findById(this.row.id)
        }else{
            if(this.row){
                this.form.pid = this.row.id
            }
        }
    },
    methods: {
        insIdsCallback(val){
            this.form.insIds = val
        },
        checkChange(obj, checked){
            if(checked){
                let arr = [obj.id]
                this.$refs.dataTree.setCheckedKeys(arr)
                this.pid = obj.id
            }
        },
        // 查询分组详情
        findById(id){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios.get( this.baseUrl3 + 'analyses/get/nodeData/' + id)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.form = data
                        this.form.insIds = data.insIds ? data.insIds : []
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(err => {
                    console.log(err)
                    loading.close();
                });
        },
        save(){
            this.$refs.form.validate(valid => {
                if(valid){
                    let loading = Loading.service({
                        fullscreen: true,
                        text: "数据加载中..."
                    });
                    let url = this.baseUrl3
                    if(this.type == 'edit'){
                        url += 'analyses/edit/dataAnalyses/treeData'
                    }else{
                        url +=  'analyses/add/dataAnalyses/treeData'
                    }
                    this.$axios.post(url, this.form)
                        .then(({ data: { msg, data, code } }) => {
                            if (code == 20000) {
                                this.cancel(true)
                            } else {
                                this.$message({ showClose: true, message: msg, type: "error" });
                                console.log(msg);
                            }
                            loading.close();
                        })
                        .catch(err => {
                            console.log(err)
                            loading.close();
                        });

                }else{
                    console.log("验证不通过")
                }
            })
        },
        cancel(val){
            this.$emit('addBoxCallback', val)
        }
    }
}
</script>
<style scoped>
.selfForm >>> .el-input{
    width: 80% !important;
}
</style>
